import { createProfiles, loadClientProfiles } from '../requests/profiles.js';
import { pendingFoods, addFood } from './ui-setup-food-form.js';
import { getProfiles, setProfiles } from '../state-manager.js';
import { setFoods } from '../state-manager.js';
import { createClientFoods, loadClientFoods, getPredefinedFoods } from '../requests/foods.js';

// Create pet
export async function quickCreatePetProfile(stageComplited) {
  try {
    const profiles = await loadClientProfiles();
    if (profiles?.length > 0) {
      console.log('[Quick CreateProfile] Profiles already exist, skipping creation.');
      stageComplited();
      return;
    }
  } catch (err) {
    console.error('[Quick CreateProfile] Profiles yest not exist:', err);
  }

  const payload = {
    name: 'My Pet',
    daily_norm: 250,
    created_at: "", // placeholder for future timestamp
  }

  try {
    const result = await createProfiles([payload]);
    if (result.success) {
      const updatedProfiles = await loadClientProfiles();
      setProfiles(updatedProfiles);
      console.log('[Quick CreateProfile] success...');
      stageComplited();
    } else {
      console.log('[Quick CreateProfile] failed.');
    }
  } catch (err) {
    console.error('[Quick CreateProfile] Error:', err);
    alert('An error occurred while creating profile.');
  }
}

export async function quickCreatePetFoods(stageComplited) {
  try {
    const existingFoods = await loadClientFoods();
    if (existingFoods?.length > 0) {
      console.log('[Quick FoodCreate] Foods already exist, skipping creation.');
      stageComplited();
      return;
    }
  } catch (err) {
    console.info('[Quick FoodCreate] Foods yet not exist:', err);
  }

  const predefinedFoods = await getPredefinedFoods();
  if (!predefinedFoods || predefinedFoods.length === 0) {
    console.warn('[Quick FoodCreate] No predefined foods found.');
    stageComplited();
    return;
  }

  const profiles = getProfiles();
  // Get all IDs
  const ids = profiles.map(profile => profile.id);
  console.log(ids); // [1, 2]  
  // Prepare foods based on predefined list
  predefinedFoods.forEach(foodTemplate => {
    const name = foodTemplate.name;
    const weight = foodTemplate.weight;
    const barcode = foodTemplate.barcode;
    addFood({ name, weight, barcode, profileIds: ids });
  });

  const payload = pendingFoods.map(f => ({
    name: f.name,
    weight: f.weight,
    barcode: f.barcode,
    profile_ids: f.profileIds,
  }));

  try {
    const result = await createClientFoods(payload);
    if (result.success) {
      const updated = await loadClientFoods();
      setFoods(updated);
      console.log('[Quick FoodCreate] success...');
      stageComplited();
    } else {
      console.log('[Quick FoodCreate] failed.');
    }
  } catch (err) {
    console.error('[Quick FoodCreate] Error:', err);
    alert('Something went wrong.');
  }  
}